import { useState, useEffect } from 'react';
import moment from 'moment';
import { useMemoizedFn } from 'ahooks';
import {
  queryDateRangeOfFinance,
  queryProjectsOfFinance,
} from '../../../../services/studioOverallDetail';
// import { getFirstDayOfYear } from '@gp/utils/common';
import { isValidNumber } from '@gp/utils/common';

export default function useInitPage(options: {
  studioId: string;
  filter: IStudioOverallDetailsFilter;
  setFilter: React.Dispatch<React.SetStateAction<IStudioOverallDetailsFilter>>;
}) {
  const { studioId, filter, setFilter } = options || {};

  const [isLoading, setIsLoading] = useState(true);

  // finance页签 有数据的时间范围
  const [dateRange, setDateRange] = useState<{
    startDate: string;
    endDate: string;
  }>({
    startDate: '',
    endDate: '',
  });
  // finance页签 projects筛选器的下拉列表数据
  // const [projects, setProjects] = useState<IStudioOverallDetailsProject[]>([]);

  /**
   * 获取finance页签 有数据的时间范围
   */
  const queryDateRange = useMemoizedFn(async (studioId: string) => {
    let startDate;
    let endDate;
    try {
      const { start_date, end_date } = await queryDateRangeOfFinance({
        studio_id: studioId,
      });
      startDate = start_date || '';
      endDate = end_date || '';
    } catch (exception) {
      console.warn(exception);
      startDate = '';
      endDate = '';
    }
    return {
      startDate,
      endDate,
    };
  });

  /**
   * 获取finance页签 projects筛选器的下拉列表数据
   */
  /* const queryProjects = useMemoizedFn(async (studioId: string, date = '') => {
    let projects: IStudioOverallDetailsProject[] = [];
    try {
      const res = await queryProjectsOfFinance({
        studio_id: studioId,
        start_date: getFirstDayOfYear(date),
        end_date: date,
      });
      projects = Array.isArray(res)
        ? res
        : ([] as IStudioOverallDetailsProject[]);
    } catch (exception) {
      console.warn(exception);
      projects = [];
    }

    return projects;
  }); */

  /* const updateProjects = useMemoizedFn(
    async (studioId: string, date: string) => {
      const projectsTemp = await queryProjects(studioId, date);
      setProjects(projectsTemp);
      return projectsTemp;
    },
  ); */

  /**
   * 串行请求有数据的时间范围、projects列表数据
   * finance页签 初始化逻辑，获取筛选器前置数据，包括 有数据的时间范围，projects筛选器的下拉列表数据，更新页面的filter
   */
  const initInOrder = async (studioId: string) => {
    const dateRangeTemp = await queryDateRange(studioId);
    const endDate = dateRangeTemp?.endDate;
    // const projectsTemp = await queryProjects(studioId, dateRangeTemp?.endDate);
    const initDate = typeof endDate === 'string' && endDate ? endDate?.slice(0, 4) || '' : '';
    const filterTemp = {
      ...filter,
      date: isValidNumber(initDate) ? initDate : '',
      // projects: projectsTemp.map((project) => project?.id),
    };
    setDateRange(dateRangeTemp);
    // setProjects(projectsTemp);
    setFilter(filterTemp);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!studioId) return;
    // initConcurrency(studioId);
    initInOrder(studioId);
  }, [studioId]);

  return {
    isLoading,
    dateRange,
    // projects,
    // updateProjects,
  };
}
